import { orderTypes } from "../actions/types"

const storedItems = localStorage.getItem('orderItems')

const initialState = {
  webOrderId: null,
  items: storedItems ? JSON.parse(storedItems) : [],
}

export const orderReducer =
  (
    state = initialState,
    action
  ) => {
    switch (action.type) {
      case orderTypes.ADD_ITEM:
        return {
          ...state,
          items: [...state.items, action.payload],
        }
      case orderTypes.EDIT_ITEM:
        return {
          ...state,
          items: state.items.map((item, index) =>
            index === action.payload.index ? action.payload.item : item
          ),
        }
      case orderTypes.REMOVE_ITEM:
        return {
          ...state,
          items: state.items.filter(item => item.productId !== action.payload),
        }
      case orderTypes.SET_ORDER_ID:
        return {
          ...state,
          webOrderId: action.payload,
        }
      case orderTypes.SET_INTEGRATION_ID:
        return {
          ...state,
          integrationId: action.payload,
        }
      case orderTypes.CLEAR:
        return {
          webOrderId: null,
          items: [],
        }
      default:
        return state
    }
  }